<template lang='pug'>
    v-card(:style=" !isMobile ? '' : 'height: 100%;' ")
        //- Delete taxes
        v-dialog(v-model='confirmationDialogTax' persistent max-width='290')
            v-card
                v-card-title.headline
                    | Confirmar
                v-card-text Estás seguro de eliminar este impuesto?
                v-card-actions
                    v-spacer
                        v-btn(color='red darken-1' text='' @click='confirmationDialogTax = false')
                            | Cancelar
                        v-btn(color='blue darken-1' text='' @click='deleteTax' :loading="loadingDeleteTax")
                            | Aceptar
        v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
            | {{ snackbar.text }}
            v-btn(dark='' text='' @click='snackbar.snackbar = false')
                | {{$t('payment.general.close')}}
        v-card-title.dialog-card-title
          p Impuestos
          v-icon(color="white" aria-label="Close" @click="$emit('Close')") mdi-close
        v-card-text(style='text-align: center;')
            v-form(ref='formTaxes' v-model='validTaxes' lazy-validation='')
                v-row
                    v-col(cols="12" md="6")
                        v-text-field(label='Nombre' v-model="tax.name" :rules='[rules.required]')
                    v-col(cols="10" md="4")
                        v-text-field(:label="currencyLabel" type="number" v-model="tax.val" :rules='[rules.required]')
                    v-col(cols="2" md="2")
                        v-checkbox(label="%" v-model="tax.percentage")
            v-row(style='height: 30vh')
                v-col(cols='12' md='12' style='padding:0px; margin:0px; overflow: auto')
                    v-simple-table(style='height: 100px;' scrollable='')
                        thead
                            tr
                                th.primary--text
                                    | Nombre
                                th.primary--text
                                    | Valor
                                th.primary--text
                                    | Porcentaje
                                th.primary--text
                                    | Acción
                        tbody
                            tr(v-for='(tax, index) in lstTaxes' :key='index')
                                td.text-left(style="cursor: pointer;" @click="editTax(tax)")
                                    | {{ tax.data.name }}
                                td.text-left(style="cursor: pointer;" @click="editTax(tax)")
                                    | {{ tax.data.val }}
                                td.text-left(style="cursor: pointer;" @click="editTax(tax)")
                                    | {{ tax.data.percentage ? 'SI' : 'NO' }}
                                td.text-left(style='cursor: pointer;')
                                    v-btn(icon='' text color='red' small='' @click="openConfimationDeleteTax(tax.id)")
                                        v-icon mdi-delete
        .text-center
          v-btn(text @click="$emit('Close')") Salir
          v-btn(text color='#008e95' @click='saveNewTax' :loading="loadingSaveTax") Guardar
</template>

<script>
  import Swal from 'sweetalert2'
  import { currencies } from '@/locales/countries.json'
  export default {
    name: 'TaxesDialog',
    data () {
      return {
        loadingDeleteTax: false,
        idTaxSelect: null,
        confirmationDialogTax: false,
        loadingSaveTax: false,
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
        rules: {
          required: value => !!value || 'Campo Requerido',
        },
        validTaxes: true,
        tax: {
          name: '',
          val: '',
          percentage: false,
        },
        dialogTaxes: false,
        dialog: false,
        createItemDialog: false,
        confirmationDialog: false,
      }
    },
    computed: {
      lstTaxes () {
        // console.log(this.$store.state.users.taxes)
        return this.$store.state.users.taxes
      },
      isMobile () {
        return window.innerWidth < 1024
      },
      currencyLabel () {
        const profile = this.$store.state.users.profile
        if (profile.direction && profile.direction.country) {
          const currencyObj = currencies.find(item => item.country === profile.direction.country)
          const currencyCode = currencyObj ? currencyObj.currency : 'COP'
          return `Valor: ${currencyCode}`
        } else {
          return 'Valor: COP'
        }
      },
    },
    mounted () {
      this.$store.dispatch('users/loadTaxesLst')
    },
    methods: {
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },

      openConfimationDeleteTax (idTax) {
        const vm = this
        vm.idTaxSelect = idTax
        Swal.fire({
          title: 'Eliminar  impuesto',
          text: '¿Deseas continuar?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2ca0a5',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.isConfirmed) {
            vm.deleteTax()
          }
        })
      },
      deleteTax () {
        this.loadingDeleteTax = true
        this.$store.dispatch('users/deleteTax', this.idTaxSelect).then(res => {
          this.confirmationDialogTax = false
          this.loadingDeleteTax = false
          this.idTaxSelect = null
          if (res) {
            this.setDataNotification(true, 'success', 'El impuesto se eliminó de manera correcta.')
          } else {
            this.setDataNotification(true, 'error', 'Error al momento de eliminar el impuesto.')
          }
        }, error => {
          console.log(error)
          this.setDataNotification(true, 'error', 'Error al momento de eliminar el impuesto.')
        })
      },
      editTax (tax) {
        this.idTaxSelect = tax.id
        this.tax = tax.data
        // console.log(tax)
      },
      saveNewTax () {
        if (this.$refs.formTaxes.validate()) {
          if (this.tax.percentage && this.tax.val > 100) {
            this.setDataNotification(true, 'error', 'El porcentaje no puede ser mayor a 100.')
            return
          }
          // console.log(this.tax)
          this.loadingSaveTax = true
          if (this.idTaxSelect) {
            const dataSend = {
              idTax: this.idTaxSelect,
              tax: this.tax,
            }
            this.$store.dispatch('users/updateTax', dataSend).then(res => {
              this.loadingSaveTax = false
              this.idTaxSelect = null
              // this.dialogTaxes = false
              this.tax = {
                name: '',
                val: '',
                percentage: false,
              }
              if (res) {
                this.setDataNotification(true, 'success', 'El impuesto se guardo de manera correcta.')
              } else {
                this.setDataNotification(true, 'error', 'Error al momento de guardar el impuesto.')
              }
            })
          } else {
            this.$store.dispatch('users/addTax', this.tax).then(res => {
              this.loadingSaveTax = false
              this.idTaxSelect = null
              // this.dialogTaxes = false
              this.tax = {
                name: '',
                val: '',
                percentage: false,
              }
              if (res) {
                this.setDataNotification(true, 'success', 'El impuesto se guardo de manera correcta.')
              } else {
                this.setDataNotification(true, 'error', 'Error al momento de guardar el impuesto.')
              }
            })
          }
        }
      },
    },
  }
</script>
